(function () {
  // === Auto-Rotation paarweise ===
  function initRotation(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mp-review]'));
    var autoRotate = root.getAttribute('data-autorotate') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (cards.length <= 2 || !autoRotate || prefersReduced) return;

    // Sichtbare Kartenanzahl: 2 auf Desktop, 1 auf Mobile
    function visibleCount() {
      return window.matchMedia('(max-width: 749px)').matches ? 1 : 2;
    }

    var pos = 0;
    var timer = null;

    function render() {
      var vis = visibleCount();
      cards.forEach(function (card, i) {
        // zeige die nächsten `vis` Karten ab pos (zyklisch)
        var show = false;
        for (var k = 0; k < vis; k++) {
          if (i === (pos + k) % cards.length) show = true;
        }
        if (show) {
          card.removeAttribute('aria-hidden');
        } else {
          card.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function advance() {
      pos = (pos + visibleCount()) % cards.length;
      render();
    }

    function start() { stop(); timer = setInterval(advance, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    window.addEventListener('resize', render);

    render();
    start();
  }

  // === Smooth-Scroll zum Judge.me-Widget ===
  function initScroll() {
    document.querySelectorAll('[data-scroll-target]').forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        var sel = cta.getAttribute('data-scroll-target');
        if (!sel) return;
        var target = document.querySelector(sel);
        if (target) {
          e.preventDefault();
          var headerOffset = 90; // ggf. an sticky Header-Höhe anpassen
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        // Wenn target nicht existiert: normaler Link-Fallback (href) greift
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mp-reviews]').forEach(initRotation);
    initScroll();
  });
})();
